<script setup lang="ts">
import { useRouter } from "vue-router";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "./../home/repeat/Navbar.vue";
import { ref } from "vue";
const router = useRouter();
const isHoveredTL = ref(false);
const isHoveredTR = ref(false);
const isHoveredBL = ref(false);
const isHoveredBR = ref(false);
// 处理鼠标悬停事件的方法
const handleMouseOver = (container: string) => {
  if (container === "inner_t_l") {
    isHoveredTL.value = true;
  } else if (container === "inner_t_r") {
    isHoveredTR.value = true;
  } else if (container === "inner_b_l") {
    isHoveredBL.value = true;
  } else if (container === "inner_b_r") {
    isHoveredBR.value = true;
  }
};

// 处理鼠标移出事件的方法
const handleMouseOut = (container: string) => {
  if (container === "inner_t_l") {
    isHoveredTL.value = false;
  } else if (container === "inner_t_r") {
    isHoveredTR.value = false;
  } else if (container === "inner_b_l") {
    isHoveredBL.value = false;
  } else if (container === "inner_b_r") {
    isHoveredBR.value = false;
  }
};
</script>

<template>
  <div class="partner">
    <div class="main">
      <div class="kong">
        <Header> </Header>
      </div>
      <div class="img_box">
        <div class="img_text">
          <div class="img_inner">
            <h2>{{ $t("system.about.partner.inner_h") }}</h2>
            <div class="img_main">
              <div>{{ $t("system.about.partner.main_d") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="wrap_title">
          <div class="title_box">
            <div class="title">
              <a class="no" href="/">{{ $t("system.home.menu.home") }}</a>
              <text>></text>
              <a class="th">{{ $t("system.home.menu.partner") }}</a>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="con_box"></div>
          <div class="footer">
            <div class="footer_box">
              <div class="f_b_inner">
                <!-- t_l -->
                <div
                  class="inner_t_l"
                  @mouseover="handleMouseOver('inner_t_l')"
                  @mouseout="handleMouseOut('inner_t_l')"
                >
                  <div class="inner_t_image">
                    <img
                      src="./../../../public/f614a47090c673ada826f32240eae3e.png"
                      alt=""
                    />
                  </div>
                  <div class="t_l_l">
                    <div class="t_l_img">
                      <img
                        src="./../../assets/imgs/1-05.png"
                        alt=""
                        :style="{ opacity: isHoveredTL ? 0 : 1 }"
                      />
                      <img
                        src="./../../assets/imgs/1-01.png"
                        alt=""
                        :style="{ opacity: isHoveredTL ? 1 : 0 }"
                      />
                    </div>

                    <div class="t_l_text">
                      {{ $t("system.about.partner.tl") }}
                    </div>
                  </div>
                </div>
                <!-- t_r -->
                <div
                  class="inner_t_r"
                  @mouseover="handleMouseOver('inner_t_r')"
                  @mouseout="handleMouseOut('inner_t_r')"
                >
                  <div class="inner_t_image">
                    <img
                      src="./../../../public/ee354cb0dd40d853c00267f8f9a9f22.png"
                      alt=""
                    />
                  </div>
                  <div class="t_r_r">
                    <div class="t_r_img">
                      <img
                        src="./../../assets/imgs/1-06.png"
                        alt=""
                        :style="{ opacity: isHoveredTR ? 0 : 1 }"
                      />
                      <img
                        src="./../../assets/imgs/1-02.png"
                        alt=""
                        :style="{ opacity: isHoveredTR ? 1 : 0 }"
                      />
                    </div>
                    <div class="t_r_text">
                      {{ $t("system.about.partner.tr") }}
                    </div>
                  </div>
                </div>
                <!-- b_l -->
                <div
                  class="inner_b_l"
                  @mouseover="handleMouseOver('inner_b_l')"
                  @mouseout="handleMouseOut('inner_b_l')"
                >
                  <div class="inner_b_image">
                    <img
                      src="./../../../public/344efb2a1eb66fb9413362831db8a07.png"
                      alt=""
                    />
                  </div>
                  <div class="b_l_l">
                    <div class="b_l_img">
                      <img
                        src="./../../assets/imgs/1-07.png"
                        alt=""
                        :style="{ opacity: isHoveredBL ? 0 : 1 }"
                      />
                      <img
                        src="./../../assets/imgs/1-03.png"
                        alt=""
                        :style="{ opacity: isHoveredBL ? 1 : 0 }"
                      />
                    </div>
                    <div class="b_l_text">
                      {{ $t("system.about.partner.bl") }}
                    </div>
                  </div>
                </div>
                <!-- b_r -->
                <div
                  class="inner_b_r"
                  @mouseover="handleMouseOver('inner_b_r')"
                  @mouseout="handleMouseOut('inner_b_r')"
                >
                  <div class="inner_b_image">
                    <img src="./../../../public/e6c801e0c4fabd96b429a8a6079c1aa.png" alt="" />
                  </div>
                  <div class="b_r_r">
                    <div class="b_r_img">
                      <img
                        src="./../../assets/imgs/1-08.png"
                        alt=""
                        :style="{ opacity: isHoveredBR ? 0 : 1 }"
                      />
                      <img
                        src="./../../assets/imgs/1-04.png"
                        alt=""
                        :style="{ opacity: isHoveredBR ? 1 : 0 }"
                      />
                    </div>
                    <div class="b_r_text">
                      {{ $t("system.about.partner.br") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"> </Navbar>
    <Lianjie></Lianjie>
  </div>
</template>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.main {
  width: 100%;
  height: auto;
  overflow: hidden;
  box-sizing: border-box;
}
.kong {
  max-width: 1200px;
  height: 120px;
}
.img_box {
  width: 100%;
  height: 553px;
  position: relative;
  background-image: url("./../../../public/hzuo.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 100%;
}
.img_text {
  width: 1519px;
  height: 173px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  line-height: 1.25;
}
.img_inner {
  align-items: center;
  width: 1230px;
  padding: 0 15px;
  height: 173px;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.img_main {
  align-items: center;
  width: 100%;
  height: 103px;
  font-size: 32px;
  line-height: 1.72;
  margin-top: 20px;
}
h2 {
  width: 100%;
  font-size: 46px;
  height: 50px;
  padding: 0;
  font-weight: bold;
  color: #20538c;
  margin: 0;
}
.wrap {
  width: 100%;
  height: auto;
  background-color: #fff;
}
.wrap_title {
  padding: 30px 0;
  width: 100%;
  color: #3e3a39;

  font-size: 14px;
  height: 86px;
}
.title_box {
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
}
.title {
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0 -8px;
}
.title a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}
.content {
  width: 100%;
  height: auto;
  padding-bottom: 20px;
}
.con_box {
  width: 100%;
  height: 550px;
  position: relative;
  padding-top: 50px;
  padding-bottom: 50px;
  background-image: url("./../../../public/999_02.jpg");
  background-attachment: local;
  background-position: 50%;
  background-size: cover;
  background-repeat: no-repeat;
}
.con_inner {
  display: flex;
  align-items: center;
  min-height: 450px;
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.box_text {
  width: 50%;
  font-size: 24px;
  line-height: 1.5;
  margin-left: auto;
}
.footer {
  width: 100%;
  height: 640px;
  padding-top: 60px;
}
.footer_box {
  width: 1230px;
  height: 580px;
  max-width: 1230px;
  margin: 0 auto;
  padding: 0 15px;
}
.f_b_inner {
  width: 100%;
  height: 100%;
  background-color: #fff;
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}
.inner_t_l,
.inner_b_r,
.inner_t_r,
.inner_b_l {
  width: 50%;
  height: 290px;
  background: #fff;
  position: relative;
  transition: background 1s ease, color 0.6s ease;
}
.inner_t_l,
.inner_b_r {
  background: #f0f0f0;
}
.inner_t_image,
.inner_b_image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 0;
  z-index: 3;
}
.inner_t_image img {
  width: 100%;
  height: 100%;
  opacity: 0;
  transform: scale(1.05);
  transition: all 0.6s ease;
}
.inner_t_image img:hover {
  opacity: 0.1;
  transform: scale(1);
}
.inner_b_image img {
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 0.6s ease;
  transform: scale(1.05);
}
.inner_b_image img:hover {
  opacity: 0.1;
  transform: scale(1);
}
.t_l_l,
.t_r_r,
.b_l_l,
.b_r_r {
  padding: 40px;
  min-height: 290px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  position: relative;
  z-index: 1;
}
.t_l_img,
.t_r_img,
.b_l_img,
.b_r_img {
  position: relative;
  width: 80px;
  margin-left: auto;
}
.t_l_img img,
.t_r_img img,
.b_l_img img,
.b_r_img img {
  display: block;
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  height: auto;
  max-width: 100%;
  transition: all 0.6s ease;
  max-height: 100%;
}

.t_l_text,
.t_r_text,
.b_l_text,
.b_r_text {
  display: flex;
  align-items: center;
  font-size: 16px;
  flex: 1 0 0;
  overflow: hidden;
  padding-top: 60px;
  padding-right: 30px;
}
.inner_t_l:hover,
.inner_t_r:hover,
.inner_b_l:hover,
.inner_b_r:hover {
  background-color: rgba($color: #292726, $alpha: 1);
  color: #fff;
}
</style>
